import { StoragePromiseType } from '@carecircle/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setStorageItem = (key: string, value: any) => {
  localStorage.setItem(key, value);
  return Promise.resolve();
};

export const getStorageItem = (key: string): StoragePromiseType =>
  new Promise((resolve) => resolve(localStorage.getItem(key) ?? ''));

export const getAppInsightsWeb = () => undefined;
